/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgDocumentation = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 4.875h-3v1h3v-1zM9.5 6.875h3v1h-3v-1zM12.5 8.875h-3v1h3v-1z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2 2.25l-.5.5v10.5l.5.5h4a1.5 1.5 0 011.3.75h1.4a1.5 1.5 0 011.3-.75h4l.5-.5V2.75l-.5-.5h-4c-.818 0-1.544.393-2 1a2.496 2.496 0 00-2-1H2zm5.5 2.5A1.5 1.5 0 006 3.25H2.5v9.5H6a2.49 2.49 0 011.5.5v-8.5zm1 8.5a2.49 2.49 0 011.5-.5h3.5v-9.5H10a1.5 1.5 0 00-1.5 1.5v8.5z"
}));

export default SvgDocumentation;